<template>
  <div>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    />
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Find Tutor ?</h3>
        <br />
        <br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;`
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div style="width: 100%" class="mt-3">
        <CCol sm="12">
          <span class="float-right mr-2">
            <br />
            <img
              @click="GoToPageFaq()"
              src="../assets/img/faq.png"
              width="40px"
            />
          </span>

          <span class="mt-5 mb-5"></span>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </CCol>
      </div>
    </div>

    <CCard class="custom-card h-100" style="margin-top: -30px">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <h4
                class="text-left mt-4 d-flex d-sm-none text-black bold"
                style="font-size: 24px"
              >
                Find tutor through this process.
              </h4>
              <br />
              <div class="mt-2" style="font-size: 16px">
                <label @click="OpenPopupInfo()">
                  Click here for further info
                  <img
                    src="../assets/img/iconInfo.png"
                    width="20px"
                    height="20px"
                    class="mr-2"
                  />
                </label>
              </div>
              <br />
              <CRow>
                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-1 mt-1"
                >
                  <div
                    class="text-center custom-width-lg p-0"
                    style="font-size: 16px"
                  >
                    <div class="mt-2">
                      <input
                        @click="OpenPopupOneToOne"
                        type="radio"
                        v-model="group"
                        value="OneToOne"
                        checked
                      />
                      <span class="text-dark">One To One</span>
                      <span @click="OpenPopupOneToOne">
                        <img
                          src="../assets/img/iconInfo.png"
                          width="20px"
                          height="20px"
                          class="ml-2"
                        />
                      </span>
                      <!-- <input
                        @click="OpenPopupGroupOfTwo"
                        type="radio"
                        class="text-dark ml-4"
                        v-model="group"
                        value="GroupOfTwo"
                        required
                      />
                      <span class="text-dark"> Group Of Two</span>
                      <span @click="OpenPopupGroupOfTwo()">
                        <img
                          src="../assets/img/iconInfo.png"
                          width="20px"
                          height="20px"
                          class="ml-2"
                        />
                      </span>-->
                    </div>
                    <br />
                    <CRow class="justify-content-center">
                      <CCol sm="12" lg="12" class="p-1">
                        <CRow>
                          <CCol sm="4" lg="4" class="mt-2">
                            <h6 class="text-left text-dark d-none d-sm-flex">
                              <strong>Student Name</strong>
                            </h6>
                          </CCol>
                          <CCol sm="8" lg="8" class="mt-2">
                            <v-select
                              ref="select"
                              v-model="SelectedStudent"
                              :options="childs"
                              label="Name"
                              placeholder="--Please Select Student Name--"
                              required
                            >
                              <span
                                slot="no-options"
                                @click="$refs.select.open = false"
                                >Please Register Student</span
                              >
                            </v-select>
                          </CCol>
                          <CCol sm="4" lg="4" class="mt-2">
                            <h6 class="text-left text-dark d-none d-sm-flex">
                              <strong>Subject</strong>
                            </h6>
                          </CCol>
                          <CCol sm="8" lg="8" class="mt-1">
                            <v-select
                              v-model="SelectedSubject"
                              :options="subjects"
                              label="SubjectName"
                              placeholder="--Please Select Subject--"
                              required
                            ></v-select>
                          </CCol>
                          <CCol sm="4" lg="4" class="mt-2">
                            <h6 class="text-left text-dark d-none d-sm-flex">
                              <strong>Level</strong>
                            </h6>
                          </CCol>
                          <CCol sm="8" lg="8" class="mt-1">
                            <v-select
                              v-model="SelectedGrade"
                              :options="grades"
                              label="GradeName"
                              placeholder="--Please Select Level--"
                              required
                            ></v-select>
                          </CCol>
                          <br />
                          <CCol sm="4" lg="4" class="mt-4">
                            <h6
                              class="text-left text-dark"
                              style="font-size: 16px"
                            >
                              <strong>Language :</strong>
                            </h6>
                          </CCol>
                          <CCol
                            sm="8"
                            lg="8"
                            class="text-left mt-2"
                            style="font-size: 15px"
                          >
                            <span v-for="item in lgs" v-bind:key="item.Id">
                              <input
                                type="checkbox"
                                v-model="item.isAccepted"
                                class="mr-2 ml-2"
                              />
                              <span class="text-dark">{{ item.Name }}</span>
                            </span>
                          </CCol>
                          <br />
                          <!-- <CCol sm="12" lg="12" class="mt-2 d-flex d-sm-none">
                            <h6 class="text-left text-dark mr-2">Language : </h6>
                            <span v-for="item in lgs" v-bind:key="item.Id">
                              <input
                                type="checkbox"
                                v-model="item.isAccepted"
                                 class="mr-2 ml-2"
                              /><span class="text-dark">
                                {{ item.Name }}
                              </span>
                            </span>
                          </CCol> 
                          <br />-->

                          <br />
                          <CCol sm="12" lg="12" class="mt-2 d-flex d-sm-none">
                            <h6
                              class="text-left text-dark mr-2"
                              style="font-size: 16px"
                            >
                              <strong>Session :</strong>
                            </h6>
                            <span
                              v-for="item in se"
                              v-bind:key="item.Id"
                              style="font-size: 15px"
                            >
                              <input
                                type="checkbox"
                                v-model="item.isAccepted"
                                class="mr-2 ml-2"
                              />
                              <span class="text-dark">{{ item.Name }}</span>
                            </span>
                          </CCol>
                          <br />
                          <CCol sm="12" lg="12" class="mt-4 d-flex d-sm-none">
                            <h6
                              class="text-left text-dark mr-2"
                              style="font-size: 16px"
                            >
                              <strong>Time :</strong>
                            </h6>
                            <span
                              v-for="item in ti"
                              v-bind:key="item.Id"
                              style="font-size: 15px"
                            >
                              <input
                                type="checkbox"
                                v-model="item.isAccepted"
                                class="mr-2 ml-2"
                              />
                              <span class="text-dark">{{ item.Name }}</span>
                            </span>
                          </CCol>
                          <br />
                          <CCol sm="12" lg="12" class="mt-4 d-flex d-sm-none">
                            <h6
                              class="text-left text-dark mr-2"
                              style="font-size: 15px"
                            >
                              <strong>Class Duration :</strong>
                            </h6>
                            <span v-if="OneToOneForm == true">
                              <span v-for="item in dur" v-bind:key="item.Id">
                                <input
                                  name="item.Id"
                                  type="radio"
                                  value="item.Id"
                                  v-model="durationID"
                                  @change="durationID = item.Id"
                                  class="mr-2 ml-2"
                                />
                                <span class="text-dark">{{ item.Name }}</span>
                              </span>
                            </span>
                            <span v-if="GroupOfTwoForm == true">
                              <span
                                v-for="item in durgroup.slice(0, 1)"
                                v-bind:key="item.Id"
                              >
                                <input
                                  name="item.Id"
                                  type="radio"
                                  value="item.Id"
                                  v-model="durationID"
                                  @change="durationID = item.Id"
                                  class="mr-2 ml-2"
                                />
                                <span class="text-dark">{{ item.Name }}</span>
                              </span>
                            </span>
                          </CCol>
                        </CRow>
                        <hr />
                        <label class="text-left text-dark">
                          Not Register as Student ? Click Here to
                          <span
                            style="text-decoration: underline; color: blue"
                            @click="GoToPageRegisterStudent"
                            >Register New Student</span
                          >
                        </label>
                        <hr />

                        <!-- <div v-if="SubmittedForm === true">
                          <h5>
                            We will list partner for you.Wait a moment ......
                          </h5>
                          <br />
                          <CButton color="success" size="lg" block disabled
                            >Submitted</CButton
                          >
                        </div>
                        <div v-else> -->
                          <CButton
                            color="success"
                            class="custom-btn"
                            size="lg"
                            block
                            :disabled="isDisabled"
                            @click="InsertNewFilter"
                            >Submit</CButton
                          >
                        <!-- </div> -->
                        <label class="mt-2 text-center">
                          “You need to make selection to all required options in
                          order to proceed.”
                        </label>
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
    <CModal
      title="Success"
      size="sm"
      color="success"
      :show.sync="successModals"
    >
      <CCol sm="12" class="text-center">
        <div class="text-center">
          <img class="m-0" width="100px" src="../assets/img/iconsuccess.png" />
        </div>
      </CCol>

      <h3 class="text-center">SUCCESS !</h3>
      <CCol sm="12">
        <label class="text-center m-0"
          >You have successfully send job to tutor.</label
        >
      </CCol>
    </CModal>

    <CModal title="Info" size="sm" color="info" :show.sync="InfoModal">
      <CCol sm="12">
        <div>
          <label>
            <strong>Info</strong>
          </label>
          <p>
            Please complete all the information needed to find the right tutor
            for you. Once this process is complete, all tutors who meet your
            needs will be notified of job offers. They may apply and you have to
            choose one of them. The tutor will accept the job and a virtual
            class code will be generated and the tutor will get your contact
            number to send for further instructions
          </p>
        </div>
      </CCol>
      <template class="modal-footer" hidden="true" #footer>
        <span></span>
      </template>
    </CModal>

    <CModal
      title="One To One"
      size="sm"
      color="info"
      :show.sync="OneToOneModal"
    >
      <CCol sm="12">
        <div>
          <p>
            <strong>One To One</strong>
            <br />This option will immediately to find tutor for you. Number of
            tutor will return your request and you can choose them
            <br />
            <br />
            <strong>Charge per session</strong>
            <br />For 40 minutes <br />- Primary (RM20) <br />- Secondary (RM24)
            <br />- Form 6 & above (RM27)
            <br />
            <br />
            <br />For 1 hour <br />- Primary(RM30) <br />- Secondary(RM35)
            <br />- Form 6 & above (RM40)
          </p>
        </div>
      </CCol>
      <template class="modal-footer" hidden="true" #footer>
        <span></span>
      </template>
    </CModal>

    <CModal
      title="Group Of Two"
      size="sm"
      color="info"
      :show.sync="GroupOfTwoModal"
    >
      <CCol sm="12">
        <div>
          <label>
            <strong>Group Of Two</strong>
          </label>
          <p>This option will give you :</p>

          <p>
            1 -
            <strong>Charge per session</strong>
          </p>
          <p>RM15 for primary</p>
          <p>RM18 for secondary</p>

          <p>
            2 -
            <strong>
              We will match you with available waiting student, if not
              available, you will be in waiting list
            </strong>
          </p>
        </div>
      </CCol>
      <template class="modal-footer" hidden="true" #footer>
        <span></span>
      </template>
    </CModal>

    <CModal
      title="Waiting List"
      size="md"
      color="info"
      :show.sync="UpdateWaitingList"
    >
      <CCol sm="12">
        <div>
          <label>
            <strong>Please Select Any One Of this Waiting List Student</strong>
          </label>
          <hr />
          <div v-if="waiting.length > 0">
            <div>
              <table style="width: 100%">
                <tbody>
                  <tr v-for="(item, index) in waiting" v-bind:key="item.Id">
                    <td style="width: 80%">{{ item.Name }}</td>
                    <td class="float-right">
                      <CButton
                        color="success"
                        class="custom-btn"
                        block
                        @click="UpdateWaiting(index)"
                        >Select</CButton
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else>
            You will be in waiting list.We will choose partner for you on
            subject you are select.
            <CButton
              color="success"
              class="custom-btn"
              block
              @click="GoToPageFindTutor()"
              >Back</CButton
            >
          </div>
        </div>
      </CCol>
    </CModal>
    <CModal
      title="Request Send."
      size="md"
      color="success"
      :show.sync="successModal"
    >
      <template class="modal-header" hidden="false" #header>
        <span>
          <strong>Request Send.</strong>
          <br />
        </span>
      </template>
      <CCol sm="12">
        <div>
          <p>
            <strong>Success</strong>
            <br />
            <br />You have successfully send job to tutor. Please wait for
            respond from a tutor to accept the job you send.
          </p>
        </div>
      </CCol>
      <template class="modal-footer" hidden="true" #footer>
        <span>
          <CButton
            color="success"
            class="custom-btn"
            block
            @click="GoToPageRequest()"
            >Close</CButton
          >
        </span>
      </template>
    </CModal>
  </div>
</template>     
<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);
import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
  },
  data() {
    return {
      backgroundUrl,
      backgroundBanner,
      lgs: [],
      se: [],
      ti: [],
      dur: [],
      durgroup: [],
      childs: [],
      students: [],
      subjects: [],
      grades: [],
      SelectedSubject: "",
      SelectedGrade: "",
      SelectedStudent: "",
      list: [],
      FilterList: [],
      SearchQuery: "",
      Busy: false,
      subjectsOptions: [],
      Success: false,
      Error: false,
      successModal: false,
      submitted: true,
      submittedData: false,
      group: "OneToOne",
      GroupOfTwoModal: false,
      OneToOneModal: false,
      UpdateWaitingList: false,
      InfoModal: false,
      waiting: [],
      types: [],
      SubmittedForm: false,
      durationID: "",

      OneToOneForm: true,
      GroupOfTwoForm: false,
    };
  },
  async mounted() {
    this.GetSubject();
    this.GetGrade();
    this.GetListOfTeacher();
    this.GetLanguages();
    this.GetSession();
    this.GetTimes();
    this.GetDurations();
    this.GetDurationsGroup();
    this.GetListChild();
    this.GetWaitingList();
    this.GetUserType();
  },
  computed: {
    isDisabled: function () {
      return (
        !this.SelectedStudent.Id ||
        !this.SelectedSubject.SubjectName ||
        !this.SelectedGrade.Id ||
        !this.group
      );
    },
  },
  methods: {
    OpenPopupInfo() {
      this.InfoModal = true;
    },
    OpenPopupOneToOne() {
      this.OneToOneModal = true;
      this.OneToOneForm = true;
      this.GroupOfTwoForm = false;
    },
    OpenPopupGroupOfTwo() {
      this.GroupOfTwoModal = true;
      this.GroupOfTwoForm = true;
      this.OneToOneForm = false;
    },
    OpenTest() {
      this.successModal = true;
    },
    // async GetWaitingList() {
    //   return this.$API
    //     .get(
    //       this.$AllWaitingList +
    //         "?subjectId=" +
    //         this.$route.query.subject +
    //         "&&levelId=" +
    //        this.$route.query.grade +
    //         "&&studentId=" +
    //        this.$route.query.student
    //     )
    //     .then(
    //       function (response) {
    //         this.waiting = response.data;
    //       }.bind(this)
    //     )
    //     .catch(function (error) {
    //       console.log(error.response);
    //     });
    // },
    async GetLanguages() {
      return this.$API
        .get(this.$Languages)
        .then(
          function (response) {
            this.lgs = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetSession() {
      return this.$API
        .get(this.$Sessions)
        .then(
          function (response) {
            this.se = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetTimes() {
      return this.$API
        .get(this.$Times)
        .then(
          function (response) {
            this.ti = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetDurations() {
      return this.$API
        .get(this.$Durations)
        .then(
          function (response) {
            this.dur = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetDurationsGroup() {
      return this.$API
        .get(this.$DurationGroups)
        .then(
          function (response) {
            this.durgroup = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetListOfTeacher() {
      this.$API
        .get(this.$ListTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.list = response.data;
            this.FilterList = this.list;
            this.getPic(this.FilterList.PicturePath);
          }
        });
    },
    async GetUserType() {
      this.$API
        .get(this.$UserType + "?userID=" + this.$route.query.userID, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.types = response.data;
            console.log("hello" + this.types);
          }
        });
    },
    getPic(index) {
      return "https://pickiddo.com/" + this.FilterList[index].PicturePath;
    },
    async GetSubject() {
      this.$API
        .get(this.$ListSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
    },
    async GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    async GetListChild() {
      this.$API
        .get(this.$ListChild + "?userID=" + this.$route.query.userID, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.childs = response.data;
          }
        });
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.list, ["Name"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ Name }) =>
          _.some([
            _.includes(!Name || Name.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilterList = result;
      }
    },
    FilterListSubject() {
      console.log("testing");
      this.FilterList = this.list;

      if (this.SelectedSubject !== "ALL SUBJECT")
        this.FilterList = _.filter(
          this.FilterList,
          (item) =>
            item.TeachingSubjectList[0].Name ===
            this.SelectedSubject.SubjectName
        );
      console.log("t" + this.SelectedSubject.SubjectName);
    },

    FilterListGrade() {
      console.log("testing");
      this.FilterList = this.list;

      if (this.SelectedGrade !== "ALL GRADE")
        this.FilterList = _.filter(
          this.FilterList,
          (item) => item.GradeList[0].Name === this.SelectedGrade.GradeName
        );
    },

    InsertNewFilter() {
      this.SubmittedForm = true;

      if (
        this.SelectedStudent.Id === "" &&
        this.SelectedSubject.SubjectName === "" &&
        this.SelectedGrade.Id === ""
      ) {
        this.Error = true;
      } else {
     

        if (this.group == "GroupOfTwo") {
          //this.successModal = true;
          const formData = new FormData();

          formData.append("IsGroup", true);
          formData.append("StudentId", this.SelectedStudent.Id);
          formData.append("DataMessage", this.SelectedSubject.SubjectName);
          formData.append("TeachingGradeId", this.SelectedGrade.Id);
          formData.append("TeachingSubjectId", this.SelectedSubject.Id);
          formData.append("DurationId", this.durationID);

          var combinedLanguage = [];
          for (let i in this.lgs) {
            let item = this.lgs[i];
            combinedLanguage.push({
              LanguageId: item.Id,
              IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
            });
          }

          let languageData = JSON.stringify(combinedLanguage);
          formData.append("Language", languageData);

          var combinedSession = [];
          for (let i in this.se) {
            let item = this.se[i];
            combinedSession.push({
              SessionId: item.Id,
              IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
            });
          }

          let sessionData = JSON.stringify(combinedSession);
          formData.append("Session", sessionData);

          var combinedTime = [];
          for (let i in this.ti) {
            let item = this.ti[i];
            combinedTime.push({
              TimeId: item.Id,
              IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
            });
          }

          let timeData = JSON.stringify(combinedTime);
          formData.append("Time", timeData);

          return this.$API
            .post(this.$StudentFilterSubject, formData, {
              withCredentials: true,
            })
            .then((response) => {
              if (response.status == 200 && response.data != null) {
                if (response.data == -1) {
                   this.$dialog
                    .alert({
                      title: "Insufficient Credit Balance",
                      body: "You have insufficient Credit balance. Please topup minimum 30 Credit Hour at ePay.",
                      icon: "info",
                    })
                    .then(function (dialog) {
                      console.log("Closed");
                    });
                } else {
                  this.$dialog
                    .alert({
                      title: "Request Send",
                      body: "Please wait to received notification from tutor. \n Thank you for using pickiddo find tutor.",
                      icon: "info",
                    })
                    .then(function (dialog) {
                      console.log("Closed");
                    });
                       this.GoToPageRequest();
                  console.log(response.data);
                }
                //  this.successModal = true;
                // this.GoToPageStatus(response.data);
              }
            })
            .catch((error) => {
              if (error.response) {
                this.Busy = false;
                this.Error = true;
                console.log(error.response.status);
              }
            });
        } else {
          //this.successModal = true;

          this.Error = false;
          const formData = new FormData();

          formData.append("IsGroup", false);
          formData.append("StudentId", this.SelectedStudent.Id);
          formData.append("DataMessage", this.SelectedSubject.SubjectName);
          formData.append("TeachingGradeId", this.SelectedGrade.Id);
          formData.append("TeachingSubjectId", this.SelectedSubject.Id);
          formData.append("DurationId", this.durationID);

          var combinedLanguage = [];
          for (let i in this.lgs) {
            let item = this.lgs[i];
            combinedLanguage.push({
              LanguageId: item.Id,
              IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
            });
          }

          let languageData = JSON.stringify(combinedLanguage);
          formData.append("Language", languageData);

          var combinedSession = [];
          for (let i in this.se) {
            let item = this.se[i];
            combinedSession.push({
              SessionId: item.Id,
              IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
            });
          }

          let sessionData = JSON.stringify(combinedSession);
          formData.append("Session", sessionData);

          var combinedTime = [];
          for (let i in this.ti) {
            let item = this.ti[i];
            combinedTime.push({
              TimeId: item.Id,
              IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
            });
          }

          let timeData = JSON.stringify(combinedTime);
          formData.append("Time", timeData);

          return this.$API
            .post(this.$StudentFilterSubject, formData, {
              withCredentials: true,
            })
            .then((response) => {
              if (response.status == 200 && response.data != null) {
                this.Busy = false;
               if (response.data == -1) {
                   this.$dialog
                    .alert({
                      title: "Insufficient Credit Balance",
                      body: "You have insufficient Credit balance. Please topup minimum 30 Credit Hour at ePay",
                      icon: "info",
                    })
                    .then(function (dialog) {
                      console.log("Closed");
                    });
                } else {
                  this.$dialog
                    .alert({
                      title: "Request Send",
                      body: "Please wait to received notification from tutor. \n Thank you for using pickiddo find tutor.",
                      icon: "info",
                    })
                    .then(function (dialog) {
                      console.log("Closed");
                    });
                       this.GoToPageRequest();
                  console.log(response.data);
                }
                //  this.successModal = true;
                // this.GoToPageStatus(response.data);
              }
            })
            .catch((error) => {
              if (error.response) {
                this.Busy = false;
                this.Error = true;
                console.log(error.response.status);
              }
            });
        }
      }
    },

    GoToPageRegisterStudent() {
      this.$router.push("/RegisterStudent?userID=" + this.$route.query.userID);
    },
    GoToPageNotification() {
      this.$router.push("/Request?userId=" + this.$route.query.userID);
    },
    GoToPageNotificationTeacher() {
      this.$router.push(
        "/NotificationTeacher?userId=" + this.$route.query.userID
      );
    },
    GoToPageWaitingList() {
      this.$router.push(
        "/ListWaiting?subjectId=" +
          this.SelectedSubject.Id +
          "&gradeId=" +
          this.SelectedGrade.Id +
          "&studentId=" +
          this.SelectedStudent.Id +
          "&userID=" +
          this.$route.query.userID
      );
    },
    GoToPageFindTutor() {
      this.$router.push("/FindSubject?userID=" + this.$route.query.userID);
    },
    GoToPageRequest() {
      this.$router.push("/ListRequest?userId=" + this.$route.query.userID);
    },
    GoToPageStatus(FindTutorId) {
      this.$router.push("/FindSubjectStatus?findTutorId=" + FindTutorId);
    },
    GoToPageFaq() {
      this.$router.push("/Faq");
    },
  },
};
</script>
